import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class PlanningDashboardBalanceViewRoute extends Route {
  model() {
    return this.modelFor('planning.dashboard.balance');
  }
}

export default instrumentRoutePerformance(PlanningDashboardBalanceViewRoute);
